"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RichText", {
  enumerable: true,
  get: function get() {
    return _RichText.default;
  }
});
exports.Span = exports.TextAlign = exports.P = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
var _functions = require("../functions");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _TextHighlight = _interopRequireDefault(require("./TextHighlight"));
var _RichText = _interopRequireDefault(require("./RichText"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Text = function Text(_ref) {
  var highlight = _ref.highlight,
    highlightLineHeight = _ref.highlightLineHeight,
    children = _ref.children,
    Component = _ref.Component,
    restProps = _objectWithoutProperties(_ref, ["highlight", "highlightLineHeight", "children", "Component"]);
  return highlight && highlight !== 'primary' ? /*#__PURE__*/_react.default.createElement(Component, restProps, /*#__PURE__*/_react.default.createElement(_TextHighlight.default, {
    highlight: highlight,
    highlightLineHeight: highlightLineHeight
  }, children)) : /*#__PURE__*/_react.default.createElement(Component, restProps, children);
};
var StyledH1 = _styledComponents.default.h1.withConfig({
  displayName: "typography__StyledH1",
  componentId: "sc-1m1v4w0-0"
})(["", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return (0, _functions.getFontStyle)(theme.typography['h1'], theme.breakpoints.md);
});
var StyledH2 = _styledComponents.default.h2.withConfig({
  displayName: "typography__StyledH2",
  componentId: "sc-1m1v4w0-1"
})(["", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return (0, _functions.getFontStyle)(theme.typography['h2'], theme.breakpoints.md);
});
var StyledH3 = _styledComponents.default.h3.withConfig({
  displayName: "typography__StyledH3",
  componentId: "sc-1m1v4w0-2"
})(["", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return (0, _functions.getFontStyle)(theme.typography['h3'], theme.breakpoints.sm);
});
var StyledH4 = _styledComponents.default.h4.withConfig({
  displayName: "typography__StyledH4",
  componentId: "sc-1m1v4w0-3"
})(["", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return (0, _functions.getFontStyle)(theme.typography['h4'], theme.breakpoints.sm);
});
var StyledH5 = _styledComponents.default.h5.withConfig({
  displayName: "typography__StyledH5",
  componentId: "sc-1m1v4w0-4"
})(["", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return (0, _functions.getFontStyle)(theme.typography['h5'], theme.breakpoints.sm);
});
var StyledP = _styledComponents.default.p.withConfig({
  displayName: "typography__StyledP",
  componentId: "sc-1m1v4w0-5"
})(["", ";"], function (_ref7) {
  var size = _ref7.size,
    _ref7$theme = _ref7.theme,
    typography = _ref7$theme.typography,
    breakpoints = _ref7$theme.breakpoints;
  var p = typography.p;
  var _getParagraphSize = (0, _functions.getParagraphSize)(p, size),
    min = _getParagraphSize.min,
    max = _getParagraphSize.max;
  return (0, _styledComponents.css)(["&,a{", ";}"], (0, _functions.getFontStyle)(typography['p'], breakpoints.sm, min, max));
});
var H1 = function H1(props) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    Component: StyledH1
  }, props, {
    highlightLineHeight: [1.8, 1.6]
  }), props.children);
};
exports.H1 = H1;
var H2 = function H2(props) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    Component: StyledH2
  }, props, {
    highlightLineHeight: [1.8, 1.65]
  }), props.children);
};
exports.H2 = H2;
var H3 = function H3(props) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    Component: StyledH3
  }, props, {
    highlightLineHeight: [1.85, 1.9]
  }), props.children);
};
exports.H3 = H3;
var H4 = function H4(props) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    Component: StyledH4
  }, props, {
    highlightLineHeight: [1.85, 1.9]
  }), props.children);
};
exports.H4 = H4;
var H5 = function H5(props) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    Component: StyledH5
  }, props, {
    highlightLineHeight: [1.95, 1.9]
  }), props.children);
};
exports.H5 = H5;
var P = function P(props) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    Component: StyledP
  }, props, {
    highlightLineHeight: [1.9, 1.9]
  }), props.children);
};
exports.P = P;
var TextAlign = _styledComponents.default.span.withConfig({
  displayName: "typography__TextAlign",
  componentId: "sc-1m1v4w0-6"
})(["display:inherit;text-align:", ";"], function (_ref8) {
  var align = _ref8.align;
  return align || 'left';
});
exports.TextAlign = TextAlign;
var Span = P;
exports.Span = Span;